module.exports = __webpack_public_path__ + "img/NLC2.a2902c6f.svg";